// extracted by mini-css-extract-plugin
export var box = "_9m-1";
export var checkboxRow = "_9m-8";
export var checked = "_9m-2";
export var descriptionSpacer = "_9m-a";
export var disabled = "_9m-3";
export var icon = "_9m-6";
export var input = "_9m-0";
export var labelSpacer = "_9m-9";
export var medium = "_9m-5";
export var small = "_9m-4";
export var text = "_9m-7";